import { getAuthData } from './storage';
import { setLoggedIn } from '../actions/auth';

export const handleAutoLogin = (dispatch) => {
    const authData = getAuthData();
    if (authData) {
        dispatch(setLoggedIn(true));
    }
};

export default handleAutoLogin;
